import CoreAnalytics from './coreAnalytics';

class AppAnalytics extends CoreAnalytics {}

export default new AppAnalytics();
